import { cloneDeep } from 'lodash';
import floor from 'lodash/floor';
import { IImageLayerProps, ILayerProps } from '@/version-types';

type Listener = () => void;

export class CropSession {
    readonly origin: ILayerProps;
    preview: ILayerProps;
    private listeners = new Set<Listener>();

    constructor(layer: ILayerProps) {
        this.origin = cloneDeep(layer);
        this.preview = cloneDeep(layer);
    }

    subscribe(listener: Listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }

    setPreview(layer: ILayerProps) {
        this.preview = layer;
        this.listeners.forEach((listener) => listener());
    }

    commit() {
        const layer = cloneDeep(this.preview);
        const { imageTransform } = layer.data as IImageLayerProps;
        imageTransform.offsetX = floor(imageTransform.offsetX, 8);
        imageTransform.offsetY = floor(imageTransform.offsetY, 8);
        this.preview = layer;
        return cloneDeep(layer);
    }
}
